import { useApolloClient, useMutation } from "@apollo/client";
import { createContext, useContext, useEffect, useState } from "react";
import { loginMutation } from "../apollo/Mutations";
import axios from "axios";
import toast from "react-hot-toast";

// Create the context with a default value of null
const AuthContext = createContext(null);

// AuthProvider component
export const AuthProvider = ({ children }) => {
    const pathname = window.location.pathname;
    const apolloClient = useApolloClient();
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authLoader, setAuthLoader] = useState(false);
    const [stage, setStage] = useState('');
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [company_id, setCompany_id] = useState('');
    const [companies, setCompanies] = useState([]);
    const [password, setPassword] = useState('');
    const [locationData, setLocationData] = useState(null);
    const lastCompany = localStorage.getItem('company_id');
    const lastEmail = localStorage.getItem('email');

    const geolocation = async () => {
        return new Promise((resolve, reject) => {
            axios.get("https://api.db-ip.com/v2/free/self")
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };

    const setAuthState = (isAuthenticated) => {
        localStorage.setItem("isAuthenticated", isAuthenticated);
        setIsAuthenticated(isAuthenticated);
    };

    useEffect(() => {
        const fetchLocation = async () => {
            try {
                const data = await geolocation();
                setLocationData(data);
            } catch (err) {
                console.log(err.message || "Something went wrong");
            }
        };

        fetchLocation();
    }, []);

    const [loginApi] = useMutation(loginMutation, {
        onCompleted: async (data) => {
            if (data.login.status_code !== 4001) {
                if (data?.login?.token) {
                    localStorage.setItem('token', data?.login?.token);
                    localStorage.setItem('refresh_token', data?.login?.refresh_token);
                    await apolloClient.resetStore();
                    setAuthState(true);
                    // navigate('/connect')
                    console.log('Auth Provider to /connect');
                    window.location.href = '/connect'
                } else {
                    console.log("🚀 ~ loginApi ~ data: 2", data.login);

                    setAuthState(false);
                    setCompanies(data?.login?.companies);
                    if (data?.login?.next_step) {
                        setStage(data?.login?.next_step);
                    }
                }
                if (data?.login?.status) {
                    toast.success(data?.login?.message);
                } else {
                    toast.error(data?.login?.message);
                }
            } else {
                setAuthState(false);
                toast.error(data?.login?.message);
            }
            console.log("🚀 ~ AuthProvider ~ data:", data);
        },
        onError: (error) => {
            setAuthState(false);
            toast.error(error?.message)
            console.log("🚀 ~ AuthProvider ~ error:", error)
        }
    })

    const login = async (code = '', company_id = '') => {
        let xmpp_token = localStorage.getItem("xmpp_tokenid")
        let json_data = { email: email, password: password, device_type: 'web', device_id: xmpp_token, countryName: locationData?.countryName, city: locationData?.city, ipAddress: locationData?.ipAddress, time: new Date().toLocaleString() }
        if (code && !company_id) {
            json_data['code'] = code
        } else if (company_id) {
            json_data['code'] = code || otp
            json_data['company_id'] = company_id
        }

        if (pathname?.includes('/signin_with_otp') && !code && !company_id) {
            json_data['type'] = 'signin_with_otp'
        }

        try {
            setAuthLoader(true)
            const { data } = await loginApi({
                variables: {
                    input: json_data
                }
            })
            if (company_id && !data?.login?.status) {
                setStage('');
            }
            setAuthLoader(false)
        } catch (error) {
            setAuthLoader(false)
            console.log("🚀 ~ login ~ error:", error)
        }
    };

    useEffect(() => {
        // Check localStorage for a saved authentication state

        const checkAuth = async () => {
            // Simulate loading user auth status (e.g., from localStorage or API)
            const savedAuthState = localStorage.getItem('isAuthenticated');
            if (savedAuthState) {
                setAuthState(JSON.parse(savedAuthState));
            } else {
                setAuthState(false);
            }
            setIsAuthLoading(false);
        };
        checkAuth();

    }, []);

    const logout = () => {
        setAuthState(false);
        localStorage.removeItem('isAuthenticated');  // Remove saved authentication state
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, isAuthLoading, authLoader, stage, login, logout, email, company_id, setCompany_id, setEmail, password, setPassword, setOtp, companies, lastCompany, lastEmail }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use auth context
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
